import { get, call } from 'vuex-pathify';

export default {
  data: () => ({
    agreeButtonLoading: false,
  }),
  computed: {
    currentLayerScope: get('layers/currentLayer@layer_scope'),
    isTopologicalLayer() {
      const { currentLayerScope } = this;
      return currentLayerScope === 'water' || currentLayerScope === 'sewer';
    },
  },
  methods: {
    deleteDatasourceFeature: call('layers/deleteDatasourceFeature'),
    deleteDatasourceFeatures: call('layers/deleteDatasourceFeatures'),
    deleteTopoDatasourceFeatures: call('layers/deleteTopoDatasourceFeatures'),
    async deleteObjectHandler() {
      if (this.isTopologicalLayer) {
        const r = await this.deleteObjectHof(this.deleteTopoDatasourceFeatures);
        if (r?.data?.data) {
          this.refreshLayersAndTable(r.data.data);
        }
      } else if (this.isMoreThanOneObjectSelected) {
        await this.deleteObjectHof(this.deleteDatasourceFeatures);
      } else {
        await this.deleteObjectHof(this.deleteDatasourceFeature);
      }
      if (this.isAnyFeatureSelected) {
        this.turnOffEditing();
      }
    },
    refreshLayersAndTable(layers) {
      this.$root.$emit('refreshTableData');
      this.$root.$emit(
        'refreshMvtSources',
        layers.map(layer => ({ id: layer, group: 'layers' })),
        true
      );
      this.$root.$emit('updateLegendStylesCounts', { layersIds: layers });
    },
  },
};
